import { ShieldX } from "lucide-react"
import { Link } from "react-router-dom"
import { cn } from "@/lib/utils"

export function NotAuthorizedPage() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <ShieldX className="h-16 w-16 text-muted-foreground" />
      <h1 className="mt-6 text-2xl font-bold">Not Authorized</h1>
      <p className="mt-2 text-muted-foreground">
        You do not have the required permissions to access this page.
      </p>
      <Link
        to="/companies/insights"
        className={cn(
          "mt-6 inline-flex items-center rounded-md border bg-background px-4 py-2 text-sm font-medium",
          "hover:bg-accent hover:text-accent-foreground"
        )}
      >
        Go to Dashboard
      </Link>
    </div>
  )
}
